export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-die-three-3bcf93c1f5789724d0690e00bcfccddf.svg";